import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock-enhanced';

class Modal {
    constructor(modalId) {
        this.modal = document.getElementById(modalId);
        if (!this.modal) {
            console.error(`Modal with id "${modalId}" not found`);
            return;
        }
        
        this.overlay = document.getElementById('modalOverlay');
        this.closeBtn = this.modal.querySelector('.booking-modal__close');
        this.content = this.modal.querySelector('.booking-modal__content');
        
        this.isOpen = false;
        this.scrollPosition = 0;
        this.init();
    }
    
    init() {
        if (this.closeBtn) {
            this.closeBtn.addEventListener('click', () => this.close());
        }
        
        if (this.content) {
            this.content.addEventListener('click', (e) => {
                e.stopPropagation();
            });
        }
    }
    
    open() {
        if (!this.modal) return;
        
        this.scrollPosition = window.pageYOffset || window.scrollY || document.documentElement.scrollTop;
        
        this.isOpen = true;
        this.modal.classList.add('booking-modal--active');
        
        if (this.overlay) {
            this.overlay.classList.add('booking-modal__overlay--active');
        }
        
        disableBodyScroll(this.modal, {
            reserveScrollbarGutter: true,
            allowTouchMove: (el) => {
                return el.closest('.booking-modal__content') !== null;
            }
        });
        
        requestAnimationFrame(() => {
            this.content.style.opacity = '0';
            this.content.style.transform = 'translateY(-20px)';
            
            requestAnimationFrame(() => {
                this.content.style.transition = 'opacity 0.3s ease, transform 0.3s ease';
                this.content.style.opacity = '1';
                this.content.style.transform = 'translateY(0)';
            });
        });
    }
    
    close() {
        if (!this.modal || !this.isOpen) return;
        
        this.content.style.transition = 'opacity 0.3s ease, transform 0.3s ease';
        this.content.style.opacity = '0';
        this.content.style.transform = 'translateY(-20px)';
        
        setTimeout(() => {
            this.isOpen = false;
            this.modal.classList.remove('booking-modal--active');
            
            if (this.overlay) {
                this.overlay.classList.remove('booking-modal__overlay--active');
            }
            
            enableBodyScroll(this.modal);
            clearAllBodyScrollLocks();
            
            requestAnimationFrame(() => {
                window.scrollTo(0, this.scrollPosition);
                
                requestAnimationFrame(() => {
                    window.scrollTo(0, this.scrollPosition);
                });
            });
            
            this.content.style.transition = '';
            this.content.style.opacity = '';
            this.content.style.transform = '';
        }, 300);
    }
    
}

export default Modal;
